module.exports = __webpack_public_path__ + "img/thumbnail_TamworthPig_f_normal.acd8f300.png";